<template>
    <div>
        <b-row>
          <b-col>
              <b-card>
                <div slot="header">
                  <strong> Transporter Master (Pending)</strong>
                  <div class="card-header-actions">
                    <button class="btn btn-sm btn-primary mr-4 btn-pill" type="button" @click="toggleTransporterInfo" :disabled="isReadOnly">
                        Add New
                    </button>
                  </div>
                </div>

                <b-row>
                    <b-col sm="12">
                        <div>
                            <b-card v-if="addInfoCard">
                              <b-form @submit.prevent="addTransporterForm('form-1')" data-vv-scope="form-1">
                                <b-row>
                                  <b-col sm="6">
                                      <b-form-group> <label for="vendortype">Type of Vendor</label>&nbsp;<span style="color: red;">*</span>
                                          <b-form-radio-group 
                                              id="vendor type" 
                                              v-model="transporterObj.vendortype" 
                                              v-validate="'required'"
                                              :options="[
                                                  { text: 'Aggregator', value: 'aggregator' }, 
                                                  { text: 'Normal', value: 'normal' }
                                              ]"
                                              name="vendor type"
                                              :class="{input: true,'is-invalid': errors.has('form-1.vendor type'),}"
                                          >
                                          </b-form-radio-group>
                                          <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                                <i
                                                class="fa fa-warning help text-danger"
                                                v-show="errors.has('form-1.vendor type')"
                                                >{{ errors.first("form-1.vendor type") }}</i
                                                >
                                            </span>
                                        </b-input-group>
                                      </b-form-group>

                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Company Name">Company Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Company Name"
                                        v-model="transporterObj.transporter_company_name" v-validate="'required|min:3|max:50'" :class="{ input: true, 'is-invalid': errors.has('form-1.Company Name'),
                                        }"
                                        placeholder="Enter Company Name"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Company Name')"
                                            >{{ errors.first("form-1.Company Name") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Owner Name">Company Owner Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Owner Name"
                                        v-model="transporterObj.transporter_name" v-validate="'required|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-1.Owner Name'),
                                        }"
                                        placeholder="Enter Company Owner Name"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Owner Name')"
                                            >{{ errors.first("form-1.Owner Name") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Email Id">Company Email Id</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Email Id"
                                        v-model="transporterObj.transporter_emailid" v-validate="'required|email'" :class="{ input: true, 'is-invalid': errors.has('form-1.Email Id'),
                                        }"
                                        placeholder="Enter Company Email Id"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Email Id')"
                                            >{{ errors.first("form-1.Email Id") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Mobile Number">Company Mobile Number</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input type="text" name="Mobile Number"
                                        v-model="transporterObj.transporter_mobilenumber" v-validate="'required|digits:10'" :class="{ input: true, 'is-invalid': errors.has('form-1.Mobile Number'),
                                        }" maxlength="10"
                                        placeholder="Enter Company Mobile Number"
                                        >
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Mobile Number')"
                                            >{{ errors.first("form-1.Mobile Number") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                        <label for="Password">Password</label>&nbsp;<span style="color: red;">*</span>
                                        <b-form-input name="Password" type="password"
                                        minlength="6" maxlength="14" v-model="transporterObj.password"
                                        v-validate="'required|min:6|max:14'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Password'),
                                        }"
                                        placeholder="Enter Password">
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Password')"
                                            >{{ errors.first("form-1.Password") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <b-col sm="6">
                                    <b-row>
                                      <b-col :sm="!transporterObj.gstnumber?12:9" :class="transporterObj.gstnumber!=''?'pr-0':'pr-3'">
                                        <b-form-group>
                                          <label for="GSTNumber">Tin Number / GST Number</label>&nbsp;<span style="color: red;"
                                          v-if="transporterObj.vendortype == 'aggregator'">*</span>
                                          <b-form-input name="GST Number" type="text"
                                          v-model="transporterObj.gstnumber" v-validate="transporterObj.vendortype === 'aggregator' ? 'required' : ''"
                                           @input="checkGSTlength(transporterObj.gstnumber)" 
                                          placeholder="Enter Tin Number / GST Number"
                                          :class="{ input: true, 'is-invalid': errors_GST,
                                          }">
                                          </b-form-input>
                                          <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                               <i class="fa fa-warning help text-danger"
                                                v-show="transporterObj.vendortype == 'aggregator' && !transporterObj.gstnumber">
                                                The GST Number field is required.
                                              </i>
                                              </span>
                                          </b-input-group>
                                      </b-form-group>
                                      </b-col>
                      
                                     <!--<b-col :sm="!transporterObj.gstnumber?0:3"  class="mt-1 pr-0">
                                        <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="addshowverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                                        <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="removeGST" @click="removevalue()">X</button>
                                      </b-col> -->
                                    </b-row>
                    
                                  </b-col>
                                  <b-col sm="6">
                                    <b-form-group>
                                      <label for="Transport Serviceability">Transport Serviceability</label>&nbsp;<span style="color: red;">*</span>
                                      <b-form-select  class="mb-3" name="Transport Serviceability"
                                      v-model="transporterObj.transportserviceability" v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-1.Transport Serviceability'),
                                      }">
                                        <option :value="selected">Please select an option</option>
                                        <option value="local">Local</option>
                                        <option value="state">State</option>
                                        <option value="regional">Regional</option>
                                        <option value="national">National</option>
                                      </b-form-select>
                                      <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.Transport Serviceability')"
                                            >{{ errors.first("form-1.Transport Serviceability") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                    </b-form-group>
                                  </b-col>
                                  <!-- <b-col sm="6">
                                      <b-form-group>
                                      <label for="promotername">Promoter Name</label>&nbsp;<span style="color: red;">*</span>
                                      <b-input-group class="mb-3">
                                          <b-form-input class="input" type="text" id="promoter name" name="promoter name" v-model="transporterObj.promotername" v-validate="'required|max:50'" :class="{
                                              input: true,'is-invalid': errors.has('form-1.promoter name'),}" placeholder="Enter Promoter Name"></b-form-input>
                                      </b-input-group>
                                      <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                            <i
                                            class="fa fa-warning help text-danger"
                                            v-show="errors.has('form-1.promoter name')"
                                            >{{ errors.first("form-1.promoter name") }}</i
                                            >
                                        </span>
                                        </b-input-group>
                                      </b-form-group>
                                  </b-col> -->
                                  <!-- <b-col sm="6">
                                    <b-form-group>
                                    <label for="gstinnumber">GSTIN Number</label>&nbsp;<span  v-if="transporterObj.vendortype && transporterObj.vendortype.toLowerCase() == 'aggregator'" style="color: red;">*</span>
                                    <b-input-group class="mb-3" v-if="transporterObj.vendortype && transporterObj.vendortype.toLowerCase() == 'aggregator'">
                                        <b-form-input class="input" type="text" id="gstin number" name="gstin number"   v-validate="'required' " v-model="transporterObj.gstinnumber" :class="{
                                            input: true,'is-invalid': errors.has('form-1.gstin number'),}" placeholder="Enter GSTIN Number"></b-form-input>
                                    </b-input-group>
                                    <b-input-group class="mb-3" v-else>
                                        <b-form-input class="input" type="text" id="gstin number" name="gstin number"  v-model="transporterObj.gstinnumber" :class="{
                                            input: true,'is-invalid': errors.has('form-1.gstin number'),}" placeholder="Enter GSTIN Number"></b-form-input>
                                            </b-input-group>
                                            <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.gstin number')"
                                                  >{{ errors.first("form-1.gstin number") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                 </b-form-group>
                                    </b-col> -->
                                    <b-col sm="6">
                                          <b-form-group>
                                          <label for="panno">PAN</label>&nbsp;<span style="color: red;">*</span>
                                          <b-input-group class="mb-3">
                                              <b-form-input class="input" type="text" id="pan number" name="pan number" v-model="transporterObj.pan" v-validate="'required|max:50'" :class="{
                                                  input: true,'is-invalid': errors.has('form-1.pan number'),}" placeholder="Enter PAN Number"></b-form-input>
                                          </b-input-group>
                                          <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.pan number')"
                                                  >{{ errors.first("form-1.pan number") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                          </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="adhaarno">Aadhaar</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" type="text" id="adhaar number" name="adhaar number" v-model="transporterObj.aadhar" v-validate="'required|max:50'" :class="{
                                                input: true,'is-invalid': errors.has('form-1.adhaar number'),}" placeholder="Enter Aadhaar Number"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.adhaar number')"
                                                  >{{ errors.first("form-1.adhaar number") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="bankcancelledcheque">Bank Cancelled Cheque</label>&nbsp;<span style="color: red;">*</span>
                                            <b-form-file
                                                type="file"
                                                v-model="transporterObj.bankcancelledcheque"
                                                placeholder="Bank Cancelled Cheque" 
                                                @change="selectBankChequeFile($event)"
                                                class="custom-border"
                                                v-validate="'required'"
                                                id="bank cancelled cheque" 
                                                name="bank cancelled cheque" :class="{
                                                input: true,'is-invalid': errors.has('form-1.bank cancelled cheque'),}"                                     >
                                                <template v-slot:file-name >
                                                    {{ bankFileName }}
                                                </template>
                                            </b-form-file>
                                            <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.bank cancelled cheque')"
                                                  >{{ errors.first("form-1.bank cancelled cheque") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="gstincertificate">GSTIN Certificate</label>&nbsp;
                                            <b-form-file
                                                type="file"
                                                v-model="transporterObj.gstincertificate"
                                                placeholder="GSTIN Certificate" 
                                                @change="selectGstinCertficateFile($event)"
                                                class="custom-border"
                                                id="gstin certficate" name="gstin certficate" 
                                                :class="{
                                                input: true,'is-invalid': errors.has('form-1.gstin certficate'),}"
                                                >
                                                <template v-slot:file-name>
                                                    {{ gstinCertficateFilename }}
                                                </template>
                                            </b-form-file>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="pincode">Pincode</label>&nbsp;
                                        <v-select v-model="transporterObj.pincode" :options="pincodes" placeholder="-- Select Pincode --" @change="pincodeChange(transporterObj.pincode)"></v-select>
                                        <b-input-group class="mb-3" >
                                            <span
                                                style="width:240px"
                                                v-show="errors.has('form-1.pincode')"
                                                class="help text-danger"
                                              
                                                >{{
                                                errors.first("form-1.pincode")
                                                }}</span
                                            >
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="address">Address</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input"  v-validate="'required'"
                                            type="text" id="address" name="address" v-model="transporterObj.address" :class="{
                                                input: true,'is-invalid': errors.has('form-1.address'),}" placeholder="Enter Address"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.address')"
                                                  >{{ errors.first("form-1.address") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6" v-if="transporterObj.pincode">
                                        <b-form-group>
                                        <label for="city">City</label>&nbsp;
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" type="text" id="city" name="city" v-model="transporterObj.city" :class="{
                                                input: true,'is-invalid': errors.has('form-1.city'),}" placeholder=""></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i class="fa fa-warning" v-show="errors.has('city')"></i>
                                            </span>
                                            <code v-show="errors.has('form-1.city')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-1.address") }}
                                            </code>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6" v-if="transporterObj.pincode">
                                        <b-form-group>
                                        <label for="state">State</label>&nbsp;
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" type="text" id="state" name="state" v-model="transporterObj.state" :class="{
                                                input: true,'is-invalid': errors.has('form-1.state'),}" placeholder=""></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i class="fa fa-warning" v-show="errors.has('state')"></i>
                                            </span>
                                            <code v-show="errors.has('form-1.state')" id="addresserrmsg" class="help text-danger">{{ errors.first("form-1.state") }}
                                            </code>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="bankname">Bank name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" v-validate="'required'"
                                            type="text" id="bankname" name="bankname" v-model="transporterObj.bankname" :class="{
                                                input: true,'is-invalid': errors.has('form-1.bankname'),}" placeholder="Enter Bank name"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.bankname')"
                                                  >{{ errors.first("form-1.bankname") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="bankaccountname">Bank Account Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" type="text"  v-validate="'required'" id="bankaccountname" name="bankaccountname" v-model="transporterObj.bankaccountname" :class="{
                                                input: true,'is-invalid': errors.has('form-1.bankaccountname'),}" placeholder="Enter Bank Account Name"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.bankaccountname')"
                                                  >{{ errors.first("form-1.bankaccountname") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="branchname">Branch Name</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input" type="text"   v-validate="'required'" id="branchname" name="branchname" v-model="transporterObj.branchname" :class="{
                                                input: true,'is-invalid': errors.has('form-1.branchname'),}" placeholder="Enter Branch Name"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.branchname')"
                                                  >{{ errors.first("form-1.branchname") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="accountnumber">Account number</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input"  v-validate="'required'" type="text" id="accountnumber" name="accountnumber" v-model="transporterObj.accountnumber" :class="{
                                                input: true,'is-invalid': errors.has('form-1.accountnumber'),}" placeholder="Enter Account number"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.accountnumber')"
                                                  >{{ errors.first("form-1.accountnumber") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                        <label for="ifsccode">IFSC Code</label>&nbsp;<span style="color: red;">*</span>
                                        <b-input-group class="mb-3">
                                            <b-form-input class="input"  v-validate="'required'" type="text" id="ifsccode" name="ifsccode" v-model="transporterObj.ifsccode" :class="{
                                                input: true,'is-invalid': errors.has('form-1.ifsccode'),}" placeholder="Enter IFSC Code"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                              <span class="icon has-text-warning">
                                                  <i
                                                  class="fa fa-warning help text-danger"
                                                  v-show="errors.has('form-1.ifsccode')"
                                                  >{{ errors.first("form-1.ifsccode") }}</i
                                                  >
                                              </span>
                                        </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <footer class="column has-text-right">
                                <b-button variant="primary" size="md" type="submit" id="submitButton">Add</b-button>
                                </footer>
                              </b-form>
                              
                            </b-card>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col sm="4">
                    <b-form-group label-cols-md="2" label="Filter" class="mb-0">
                        <b-input-group>
                          <b-form-input
                             v-model="filter"
                             placeholder="Enter Id/Name"
                             class="w-60"  
                          ></b-form-input>

                        <!-- <b-form-input
                            v-model="filter"
                            placeholder="Type to Search"
                        ></b-form-input> -->
                        <b-col sm="4">    
                    <b-button 
                      @click="getTransporterList()"
                      size="md"
                      variant="primary"
                      >Search</b-button>
                      </b-col>
                    &nbsp;
                    <b-button @click="clearSearch()" size="md" variant="danger"
                      >Clear</b-button> 
                          <!-- <b-button
                      @click="getTransporterList()"
                      size="sm"
                      variant="primary"
                      >Search</b-button>
                            <b-button :disabled="!filter" @click="filter = ''"
                            >Clear</b-button> -->
                        
                        </b-input-group>
                    </b-form-group>
                 </b-col>
                     <b-col sm="5">
                     <b-form-group label-cols-sm="4" label="Approval Level:" class="mb-0">
                          <b-form-select v-model="selectedApprovalLevel" @change="handleFilterChange">
                            <option value="">All Levels</option>
                            <option value="1">L1</option>
                            <option value="2">L2</option>
                            <option value="3">L3</option>
                          </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="3" class="text-right">
                        <p>
                            <b>Total Records :<span style="color:red;">{{totalRows}}</span></b
                            >
                        </p>
                    </b-col>
                    <b-col sm="12">
                     <!-- Dropdown for filtering -->
                       
                        <b-table show-empty responsive :items="transporter_data" :busy="isBusy"  :current-page="currentPage" :fields="fields" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered">
                          <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>

                          <template slot="createddate" slot-scope="row">
                            <div>
                                {{ row.item.createddate | ConvertTime12hour() }}
                            </div>
                          </template>

                          <template slot="tingstnumber" slot-scope="row">
                            <div>
                                {{ row.item.transporter_gst_no  }}
                            </div>
                          </template>

                          <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                            </div>
                          </template>

                           <template slot="invoice_status" slot-scope="row">
                            {{row.item.nextreviewer=='1' && row.item.approver_status=='pending'?'L1 Pending':
                            
                            row.item.nextreviewer=='1' && row.item.approver_status=='approved'?'L1 Approved':
                            
                            row.item.nextreviewer=='2' && row.item.approver_status=='pending'?'L1 Approved':

                            row.item.nextreviewer=='2' && row.item.approver_status=='approved'?'L2 Approved':

                            row.item.nextreviewer=='3' && row.item.approver_status=='pending'?'L2 Approved':

                            row.item.nextreviewer=='3' && row.item.approver_status=='approved'?'Approved':''}}
                          </template>
                          <template slot="isactive" slot-scope="row">
                            <span
                              @click="toggleInfoModal(row.item)"
                              style="cursor:pointer;"
                            >
                              <span
                                data-toggle="tooltip"
                                title="InActive"
                                v-if="row.item.isactive === '0'"
                              >
                                <span class="badge badge-danger">Inative</span>
                              </span>
                              <span data-toggle="tooltip" title="Active" v-else>
                                <span class="badge badge-success">Active</span>
                              </span>
                            </span>
                          </template>
   
                          <template slot="action" slot-scope="row">

                            <!-- v-if="(row.item.nextreviewer=='1' && approvedLevel=='l1' && row.item.approver_status=='pending') || (row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='pending')" -->

                            <b-button size="sm" @click="updateModal(row.item)" title="Success" variant="success" class="custom-open-modal" :disabled="isReadOnly"  v-if="(row.item.nextreviewer=='1' && approvedLevel=='l1' && row.item.approver_status=='pending') || (row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='pending')">
                              <i class="fa fa-check" aria-hidden="true"></i>
                            </b-button>
                            &nbsp; <!-- This adds a small space between the buttons -->
                            <b-button size="sm" @click="RejectModal(row.item)" title="Reject" variant="danger" class="custom-close-modal" :disabled="isReadOnly"  v-if="(row.item.nextreviewer=='1' && approvedLevel=='l1' && row.item.approver_status=='pending') || (row.item.nextreviewer=='2' && approvedLevel=='l2' && row.item.approver_status=='pending') || (row.item.nextreviewer=='3' && approvedLevel=='l3' &&  row.item.approver_status=='pending')">
                              <i class="fa fa-times" aria-hidden="true"></i>
                            </b-button> &nbsp;
                            <b-button variant="primary"  class="custom-submit" size="sm" @click="transporterMasterLog(row.item.transporter_id)">Log</b-button>

                          </template>
                        </b-table>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col md="6" class="my-1" v-if="totalRows>20">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                
                  </b-col> 
                </b-row>

                
                <b-modal title="Approve Registration" size="lg" v-model="updateInfo" @ok="updateInfo == false" hide-footer>
                  <b-row>
                    <b-col sm="12">
                      <b-form @submit.prevent="editTransporterForm('form-1')" data-vv-scope="form-1" class="text-center">
                        <b-row class="mb-4">
                          <div class="col-12">
                            Please Confirm the registration of the below transporter.
                          </div>
                        </b-row>
                        <b-row class="mb-5 text-center">
                          <div class="col-3">
                            <div><strong>Transporter Name</strong></div>
                            <div>{{ updatetransporterObj.transporter_company_name }}</div>
                          </div>
                          <div class="col-3">
                            <div><strong>Company Name</strong></div>
                            <div>{{ updatetransporterObj.transporter_name }}</div>
                          </div>
                          <div class="col-3">
                            <div><strong>Transporter Mob. No.</strong></div>
                            <div>{{ updatetransporterObj.transporter_mobilenumber }}</div>
                          </div>
                          <div class="col-3">
                            <div><strong>Transporter Email Id</strong></div>
                            <div>{{ updatetransporterObj.transporter_emailid }}</div>
                          </div>
                        </b-row>

                        <footer class="column has-text-center mb-4">
                          <b-button class="custom-submit" size="md" type="submit" @click.prevent="PendingIncidentBtn(updatetransporterObj, 'approveIncident')">Confirm</b-button>
                          &nbsp;
                          <b-button class="custom-close" size="md" type="submit" @click.prevent="closePendingIncidentModal('approveIncident')">Close</b-button>
                        </footer>
                      </b-form>
                    </b-col>
                  </b-row>
                      <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                        <br/>
                       <span class="loading" style="color:#fff;">Loading...</span>
                      </div>
                </b-modal>
                
              </b-card>
          </b-col>
        </b-row>

          <b-modal  title="Reject Registration"  size="lg" v-model="rejectInfo" @ok="rejectInfo==false" hide-footer class="text-center">
            <b-row>
              <b-col sm="12">   
                <b-form @submit.prevent="editTransporterForm('form-1')" data-vv-scope="form-1" class="text-center">
                      <b-row class="mb-4 text-center">
                          <div class="col-12">
                            Please provide a reason for rejecting the registration of below transporter.
                          </div>
                      </b-row>
                      <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
                  <br/>
                  <span class="loading" style="color:#fff;">Loading...</span>
                </div>
                      <b-row class="mb-5">
                          <div class="col-3">
                              <div><strong>Transporter Name</strong></div>
                              <div>{{ updatetransporterObj.transporter_company_name}}</div>
                          </div>
                          <div class="col-3">
                                  <div><strong>Company Name</strong></div>
                                  <div>{{ updatetransporterObj.transporter_name }}</div>
                              </div>
                              <div class="col-3">
                                  <div><strong>Transporter Mob. No.</strong></div>
                                  <div>{{updatetransporterObj.transporter_mobilenumber}}</div>
                              </div>
                              <div class="col-3">
                                  <div><strong>Transporter Email Id</strong></div>
                                  <div>{{updatetransporterObj.transporter_emailid}}</div>
                              </div>
                      </b-row>
                      <b-row class="mb-4">
                          <div class="col-3">
                              <strong>Reason:-</strong>
                          </div>
                          <div class="col-6">
                          <b-form-textarea
                              id="textarea-default"
                              placeholder="Please Enter Reason"
                              v-model.trim="updatetransporterObj.rejectReason"
                              maxlength="250"
                          ></b-form-textarea>
                          </div>
                      </b-row>
                      
                      <footer class="column has-text-center mb-4">
                        <b-button class="custom-submit" size="md" type="submit" @click.prevent="PendingIncidentBtn(updatetransporterObj, 'rejectIncident')" :disabled="!updatetransporterObj.rejectReason">Confirm</b-button>
                        &nbsp;
                        <b-button class="custom-close" size="md" type="submit" @click.prevent="closePendingIncidentModal('rejectIncident')">Close</b-button>
                      </footer>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
            <!-- Transporter Log Popup Modal -->
            <b-modal ref="transporterLogModal" title="Transporter Log Details" hide-footer  size="xl">
              <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
                  <br/>
                  <span class="loading" style="color:#fff;">Loading...</span>
                </div>
                <div>
                  <table class="table table-bordered mt-3">
                    <thead>
                      <tr>
                        <th>           
                        Sr.no
                        </th>
                        <th>Transporter ID</th>
                          <th>Status</th>
                          <th>Createdby</th>                           
                          <th>User Approval Level</th>
                            <th>Total Approval Levels</th>
                            <th>Reject Reason</th>
                          <th>Created Date</th>
                      </tr>
                    </thead>
                    <tbody v-if="arrTransporterLog.length > 0">
                      <tr v-for="(item, index) in arrTransporterLog" :key="index">
                        <td>{{(index+1)}}</td>
                        <td>{{ item.transporter_id }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ item.createdby }}</td>
                        <td>{{ item.user_approval_level }}</td>
                        <td>{{ item.total_approval_levels }}</td>
                        <td>{{ item.reject_reason|| '-'}}</td>
                        <td>{{ formatDate(item.createdat) }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">Records Not Created By Transporter</td>
                      </tr>
                    </tbody>
                  </table>
                </div>    
                <!-- Footer with Approve and Reject with Remark Buttons -->
                <div class="text-right mt-3"  v-if="arrTransporterLog.length > 0">    
                  <b-button variant="secondary" @click="$refs.transporterLogModal.hide()">Close</b-button>
                </div>    
            </b-modal>
             <!-- Confirmation Box -->
             <b-modal 
             title="Confirmation Box" v-model="toggleInfo" size="md"  @ok="toggleInfo =false"
             >
               <template slot="modal-header" slot-scope="{ close }">
                 <h5>Confirmation Box</h5>
               </template>
               <template slot="default" slot-scope="{ hide }">
                 <form v-on:submit.prevent="activateinactivateTransporter(value)">
                   <div class="modal-background"></div>
                   <div class="modal-card">
                     <section class="modal-card-body">
                       <input
                         type="hidden"
                         v-model="customer.isactive"
                         name="isactive"
                         id="modalIsActiveChk"
                       />
                       <span>Are you sure you want to change the status?</span>
                     </section>
                     <footer>
                       <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                     </footer>
                   </div>
                 </form>
               </template>
               <template slot="modal-footer" slot-scope="{ cancel }">
                 <!-- Emulate built in modal footer ok and cancel button actions -->
                 <b-button size="sm" variant="danger" @click="cancel()">
                   Cancel
                 </b-button>
               </template>
             </b-modal>
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
const axios = require('axios')
import Swal from 'sweetalert2';

export default {
    data(){
        return {
          loader:false,
          selectedApprovalLevel: "", 
            transporterObj:{
              transportserviceability:null
            },
            totalRows:0,
            fields: [
                { key: "transporter_id", label: "Register ID", sortable: true },
                { key: "transporter_company_name", label: "Company Name", sortable: true },
                { key: "transporter_name", label: "Owner Name", sortable: true },
                { key: "transporter_emailid", label: "Email Id", sortable: true },
                { key: "transporter_mobilenumber", label: "Mobile Number", sortable: true },
                { key: "tingstnumber", label: "TIN/GST Number", sortable: true },
                {key: 'invoice_status', label: 'Approval Status', sortable: true},
                {key: 'no_of_levels', label: 'No Of Levels', sortable: true},

                {key: 'registered_from', label: 'Registered from', sortable: true},
                { key: "createddate", label: "Created Date", sortable: true },
                { key: "lastmodifiedby", label: "Last Modified By",sortable: true},
                { key: "lastmodifieddate", label: "Last Modified Date",sortable: true},
                { key: "isactive", label: "IsActive", sortable: true },
                { key: "action", label: "Actions",sortable: true},
            ],
            transporter_data:[],
            bordered: true,
            currentPage: 1,
            perPage: 20,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: "asc",
            filter:'',
            isBusy:false,
            addInfoCard:false,
            updateInfo:false,
            updatetransporterObj :{},
            // add
            errors_GST:false,
            errors_showGST:{},
            removeGST:false,
            addshowverifybutton:false,
            // edit
            update_errors_GST:false,
            update_errors_showGST:{},
            update_removeGST:false,
            showverifybutton:false,
            rejectInfo: false,
            accessBody:[],
            isReadOnly:false,
            selectedBankCheque: '',
            pincodes: [],
            pincodeCityData: [],
            bankFileName: '',
            bankcancelledcheque: '',
            bankFileType: '',
            selectedGstinCertficate: '',
            gstincertificate: '',
            gstinCertficateType: '',
            gstinCertficateFilename: '',
            approveAction:[],
            approvedLevel:'',
            isSubmitButtonDisabled: false,
            arrTransporterLog: [],
            tripLevelInvoiceApproval: null,
            tripLevelInvoiceApprovalLevel:"",
            toggleInfo: false,
            customer :{},
        }
    },
    created(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.accessBody = userInfo.body;
      if (userdata && userInfo.approval_action && userInfo.approval_action!='') {

      this.tripLevelInvoiceApproval = userInfo.approval_action.find(action => action.module === "vendor_onboarding");
      // Log the result (or handle it as needed)
      if (this.tripLevelInvoiceApproval && this.tripLevelInvoiceApproval.level) {
       console.log('tripLevelInvoiceApproval Level--------------------');
        this.tripLevelInvoiceApprovalLevel = this.tripLevelInvoiceApproval.level.replace('l', '');
        this.selectedApprovalLevel=this.tripLevelInvoiceApprovalLevel;

      }
      console.log('tripLevelInvoiceApproval Level',this.tripLevelInvoiceApprovalLevel);
     }

      var approval_action = localStorage.getItem("approval_action");
      if (approval_action) {
        var approval_actionInfo = JSON.parse(approval_action);
        this.approveAction = approval_actionInfo; 
        this.getapprovedActionUser()
      }

      this.ischeckbodyvalidation();
      this.getTransporterList();
    },
    methods:{
      toggleInfoModal: function(value) {
      this.customer = value;

      this.toggleInfo = !this.toggleInfo;
    },

    activateinactivateTransporter: function(value) {
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
        // console.log("activeInactiveVal",activeInactiveVal);
      } else {
        activeInactiveVal = "1";
        // console.log("activeInactiveVal1",activeInactiveVal);
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        // deliveryagentmasterid: deliveryagentmasterId,
        transporterId: this.customer.transporter_id,
        isactive: activeInactiveVal,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
      };
      console.log("JJJJJJJJ", customerGetobj);
      // return false;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/activateinactivateTransporter`,
        customerGetobj)
      .then((result) => {
        console.log("result", result);
        if (result.body.returnmsg === "Successfull") {
          // alert("Shipments are Allocated so can not InActive");
          this.$fire({
            text: "Status Changed Successfully",
            type: "success",
            timer: 30000,
          });

          this.toggleInfo = false;
          this.getTransporterList();
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000,
          });
          this.toggleInfo = false;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
    },
      formatStatus(item) {
        // Assuming both fields exist in the item object
        const invoiceStatus = item.approver_status || 'N/A'; // Default if null
        const nextReviewer = item.nextreviewer ? `L${item.nextreviewer}` : ''; // Prefix with 'L' if exists
        // Return values based on condition
        return nextReviewer ? `${nextReviewer} - ${invoiceStatus}` : invoiceStatus;
      },
      formatDate(date) {
        if (!date) return 'N/A'; // Fallback if date is null or undefined
        const parsedDate = new Date(date);
        return parsedDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      },
      transporterMasterLog(transporter_id) {   
        console.log('transporterMasterLog',transporter_id);
        this.remark = '';
        this.loader = true;
        const obj = {
          transporterId: transporter_id
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterMasterLog`, obj).then(result => {
          console.log('getTransporterMasterLog',result.body);
          this.loader = false;
          if (result.body.returnstatus === 'Successful') {
            this.arrTransporterLog = result.body.returnvalue;
          } else {
            this.arrTransporterLog = [];
          }
        }).catch(ex => {
          console.error('Error fetching invoice list:', ex);
        }).finally(() => {
          this.loader = false;
        });

        // Show dispute confirmation modal
        this.$refs.transporterLogModal.show();
      },
      getapprovedActionUser(){
       for (var i = 0; i < this.approveAction.length; i++) {
         this.approveAction[i]
         console.log("====================",this.approveAction[i].module)
         if(this.approveAction[i].module==='vendor_onboarding'){
           this.approvedLevel = this.approveAction[i].level;
         }
       }
      },

      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Transporter Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Transporter Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
      },
       handleFilterChange() {
        console.log("Selected Approval Level:", this.selectedApprovalLevel);
        this.tripLevelInvoiceApprovalLevel=this.selectedApprovalLevel;
        this.getTransporterList();
      },
     
      getTransporterList(){
            this.isBusy=false;
            const approvalLevel = this.tripLevelInvoiceApprovalLevel != null ? this.tripLevelInvoiceApprovalLevel : "";
            console.log('--getTransporterList--',approvalLevel);
            const Obj = {
                status: "Pending",
                tripLevelInvoiceApprovalLevel:approvalLevel,
                vehiclefilter: this.filter==null?'':this.filter,

            };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTransporterEmailIdListNew`, Obj).then((result)=>{
            this.isBusy=false;
          if (result.body.returnmsg === "Successful") {
            this.transporter_data=result.body.returnvalue;
            console
            this.totalRows=result.body.returnvalue.length;
          } else {
            this.transporter_data=[];
            this.totalRows=0;
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      toggleTransporterInfo(){
        this.getPincodeList()
        this.addInfoCard = !this.addInfoCard;
        this.transporterObj={};
      },

      checkGSTlength(value){
        if (value.length>0) {
          this.addshowverifybutton=true;
          //document.getElementById("submitButton").disabled = true; 
        }
        else{
          this.addshowverifybutton=false;
          this.transporterObj.gstnumber='';
          this.errors_GST = false;
          this.errors_showGST= {};
          document.getElementById("submitButton").disabled = false;
          this.removeGST=false;
        }
      },

      verifyGSTNo(){
        document.getElementById("overlay").style.display = "block";
          const infoObj = {
            Gstin:this.transporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlay").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton").disabled = false;
              this.addshowverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.errors_GST = false;
              this.errors_showGST.transporter_gstnumber=''
              this.removeGST=false;
            } else {
              this.errors_GST = true;
              this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        // if (this.transporterObj.gstnumber) {
        //   this.errors_GST = true;
        //   this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton").disabled = false;
        // }
      },

      removevalue(){
        this.addshowverifybutton=false;
        this.transporterObj.gstnumber='';
        this.errors_GST = false;
        this.errors_showGST= {};
        document.getElementById("submitButton").disabled = false;
        this.removeGST=false;
      },

      addTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
          console.log("result",result)
        if (result) {
            this.addTransporterInfo();
        }
        });
      },

      addTransporterInfo(){
        document.getElementById("overlay").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_company_name:this.transporterObj.transporter_company_name,
                transporter_name:this.transporterObj.transporter_name,
                transporter_emailid:this.transporterObj.transporter_emailid,
                transporter_mobilenumber:this.transporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.transporterObj.gstnumber}`,
                password:this.transporterObj.password,
                createdby:`${userInfo.sysemailid}`,
                transportserviceability:this.transporterObj.transportserviceability,
                pincode: this.transporterObj.pincode ? this.transporterObj.pincode.label.toString() : null,
                address: this.transporterObj.address ? this.transporterObj.address : '',
                city: this.transporterObj.city ? this.transporterObj.city : '',
                promotername: this.transporterObj.promotername ? this.transporterObj.promotername : '',
                state: this.transporterObj.state ? this.transporterObj.state : '',
                pan: this.transporterObj.pan ? this.transporterObj.pan : '',
                bankname: this.transporterObj.bankname ? this.transporterObj.bankname : '',
                bankaccountname: this.transporterObj.bankaccountname ? this.transporterObj.bankaccountname : '',
                branchname: this.transporterObj.branchname ? this.transporterObj.branchname  : '',
                accountnumber: this.transporterObj.accountnumber ? this.transporterObj.accountnumber : '',
                ifsccode: this.transporterObj.ifsccode ? this.transporterObj.ifsccode : '',
                aadhar: this.transporterObj.aadhar? this.transporterObj.aadhar : '',
                vendortype: this.transporterObj.vendortype ? this.transporterObj.vendortype : '',
                bankcancelledcheque: this.bankcancelledcheque ? this.bankcancelledcheque : '',
                gstincertificate: this.gstincertificate ? this.gstincertificate : '',
                // gstinnumber: this.transporterObj.gstinnumber ? this.transporterObj.gstinnumber : ''
               
            };
            console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/InsertTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.getTransporterList();
            this.toggleTransporterInfo();
           
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      updateModal(data){
        this.addInfoCard = false
        console.log("data",data);
        this.updatetransporterObj={};
        this.updatetransporterObj.transporter_id=data.transporter_id
        this.updatetransporterObj.transporter_company_name =data.transporter_company_name
        this.updatetransporterObj.transporter_name =data.transporter_name
        this.updatetransporterObj.transporter_emailid =data.transporter_emailid
        this.updatetransporterObj.transporter_mobilenumber =data.transporter_mobilenumber
        this.updatetransporterObj.gstnumber=data.transporter_gst_no
        this.updatetransporterObj.nextreviewer=data.nextreviewer
        this.updatetransporterObj.no_of_levels=data.no_of_levels
        this.updatetransporterObj.approver_status=data.approver_status
        this.updateInfo = !this.updateInfo;    
      },

      RejectModal(data) {
        this.addInfoCard = false
        this.updatetransporterObj={};
        this.updatetransporterObj.transporter_id=data.transporter_id
        this.updatetransporterObj.transporter_company_name =data.transporter_company_name
        this.updatetransporterObj.transporter_name =data.transporter_name
        this.updatetransporterObj.transporter_emailid =data.transporter_emailid
        this.updatetransporterObj.transporter_mobilenumber =data.transporter_mobilenumber
        this.updatetransporterObj.gstnumber=data.transporter_gst_no
        this.updatetransporterObj.nextreviewer=data.nextreviewer
        this.updatetransporterObj.no_of_levels=data.no_of_levels
        this.updatetransporterObj.approver_status=data.approver_status
        this.rejectInfo = !this.rejectInfo;
      },

      updatecheckGSTlength(value){
        if (value.length>0) {
          this.showverifybutton=true;
          document.getElementById("submitButton1").disabled = true; 
        }
        else{
          this.showverifybutton=false;
          this.updatetransporterObj.gstnumber='';
          this.update_errors_GST = false;
          this.update_errors_showGST= {};
          document.getElementById("submitButton1").disabled = false;
          this.updateremoveGST=false;
        }
      },

      updateverifyGSTNo(){
        document.getElementById("overlayModal").style.display = "block";
          const infoObj = {
            Gstin:this.updatetransporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlayModal").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton1").disabled = false;
              this.showverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.update_errors_GST = false;
              this.update_errors_showGST.transporter_gstnumber = '';
              this.update_removeGST=false;
            } else {
              this.update_errors_GST = true;
              this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.update_removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });

        // if (this.updatetransporterObj.gstnumber) {
        //   this.update_errors_GST = true;
        //   this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.update_removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton1").disabled = false;
        // }
      },

      updateremovevalue(){
        this.showverifybutton=false;
        this.updatetransporterObj.gstnumber='';
        this.update_errors_GST = false;
        this.update_errors_showGST= {};
        document.getElementById("submitButton1").disabled = false;
        this.update_removeGST=false;
      },

      editTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
        if (result) {
            this.editTransporterInfo();
        }
        });
      },

      editTransporterInfo(){
        document.getElementById("overlayModal").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_id:this.updatetransporterObj.transporter_id,
                transporter_company_name:this.updatetransporterObj.transporter_company_name,
                transporter_name:this.updatetransporterObj.transporter_name,
                transporter_emailid:this.updatetransporterObj.transporter_emailid,
                transporter_mobilenumber:this.updatetransporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.updatetransporterObj.gstnumber}`,
                lastmodifiedby:`${userInfo.sysemailid}`,
                updated_from:'FTL'
               
            };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.updatetransporterObj={}
            this.updateInfo = false; 
            this.getTransporterList();      
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      PendingIncidentBtn(updatetransporterObj, reason) {
        console.log("updatetransporterObj",updatetransporterObj)        
        if (reason === 'rejectIncident') {
          Swal.fire({
              title: "<h4>Confirm Approval</h4><hr>",
              html: `
                  Are you sure you want to reject this transporter
              `,
              showCancelButton: true,
              confirmButtonText: "Confirm",
              confirmButtonColor: "#00c0ef",
              cancelButtonText: "Close",
              cancelButtonColor: "#F8943F",
          }).then((result) => {
              console.log("result", result);
              
              if (result.isConfirmed) {
                 document.getElementById("overlay").style.display = "block";
                let userdata = localStorage.getItem("userData");
                let userInfo = JSON.parse(userdata);
                    const infoObj = {
                        transporter_company_name:updatetransporterObj.transporter_company_name,
                        transporter_name:updatetransporterObj.transporter_name,
                        transporter_emailid:updatetransporterObj.transporter_emailid,
                        transporter_mobilenumber:updatetransporterObj.transporter_mobilenumber,
                        transporter_id:this.updatetransporterObj.transporter_id.toString(),
                        reject_reason: this.updatetransporterObj.rejectReason,
                        nextreviewer:this.updatetransporterObj.nextreviewer,
                        no_of_levels:this.updatetransporterObj.no_of_levels,
                        user_approval_level:this.updatetransporterObj.nextreviewer,
                        // approver_status:this.updatetransporterObj.approver_status,
                        lastmodifiedby :`${userInfo.sysemailid}`
                    };
                    console.log("infoObj",infoObj);
                this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/rejectPendingTransporter`, infoObj).then((result)=>{
                  document.getElementById("overlay").style.display = "none";
                  if (result.body.returnmsg === "Successful") {
                    this.$fire({
                      text: result.body.returnvalue,
                      type: "success",
                      timer: 30000,
                    });
                    this.updatetransporterObj={}
                     this.closePendingIncidentModal(reason)
                    this.getTransporterList();
                   
                  } else {
                    this.$fire({
                      text: result.body.returnvalue,
                      type: "error",
                      timer: 30000,
                    });
                  }
                }).catch((ex) => {
                  console.log("error", ex);
                });
              }
              else {
                  this.updatetransporterObj={}
                  this.closePendingIncidentModal(reason)
              }
            })
           
        }
        if (reason === 'approveIncident') {
          Swal.fire({
              title: "<h4>Confirm Approval</h4><hr>",
              html: `
                  Are you sure you want to approve this transporter
              `,
              showCancelButton: true,
              confirmButtonText: "Confirm",
              confirmButtonColor: "#00c0ef",
              cancelButtonText: "Close",
              cancelButtonColor: "#F8943F",
          }).then((result) => {
              console.log("result", result);
              
              if (result.isConfirmed) {
                  this.loader=true;
                  console.log("this.approvedLevel",this.approvedLevel=='l1')
                  let userdata = localStorage.getItem("userData");
                  let userInfo = JSON.parse(userdata);

                  const l1 = l1;
                  const l2 = l2;
                  const l3 = l3;

                  const infoObj = {
                      transporter_company_name:updatetransporterObj.transporter_company_name,
                      transporter_name:updatetransporterObj.transporter_name,
                      transporter_emailid:updatetransporterObj.transporter_emailid,
                      transporter_mobilenumber:updatetransporterObj.transporter_mobilenumber,
                      transporter_id:this.updatetransporterObj.transporter_id.toString(),
                      nextreviewer:this.updatetransporterObj.nextreviewer,
                      no_of_levels:this.updatetransporterObj.no_of_levels,
                      user_approval_level:this.updatetransporterObj.nextreviewer,
                      // approver_status:this.updatetransporterObj.approver_status,
                      lastmodifiedby :`${userInfo.sysemailid}`
                     
                  };
                  console.log("infoObj",infoObj);
                  // return false;
                  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateApproveToPendingTransporter`, infoObj).then((result)=>{
                   this.loader=false;
                  if (result.body.returnmsg === "Successful") {
                    this.$fire({
                      text: result.body.returnvalue,
                      type: "success",
                      timer: 30000,
                    });
                    this.updatetransporterObj={}
                     this.closePendingIncidentModal(reason)
                    this.getTransporterList();
                   
                  } else {
                    this.$fire({
                      text: result.body.returnvalue,
                      type: "error",
                      timer: 30000,
                    });
                  }
                }).catch((ex) => {
                  console.log("error", ex);
                });
              }
              else {
                  this.updatetransporterObj={}
                  this.closePendingIncidentModal(reason)
              }
          })          
        }        
      },
      closePendingIncidentModal(close) {
        console.log("==========>>>>>>>>>>>>>>>",close)
        if (close === 'rejectIncident') {
          this.rejectInfo = false;
        }
        if (close === 'approveIncident') {
          this.updateInfo = false;
        }
      },
      selectBankChequeFile(event){
            this.selectedBankCheque= event.target.files[0];            
            if (this.selectedBankCheque) {
                this.bankFileName = `${event.target.files[0].name}`; 
            }
            this.bankFileType = this.selectedBankCheque.type;
            this.uploadBankCheque(this.selectedBankCheque);
      },

        uploadBankCheque : function () {
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData);
            let data = new FormData();
            data.append('file', this.selectedBankCheque)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.bankcancelledcheque=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        selectGstinCertficateFile(event){
            this.selectedGstinCertficate= event.target.files[0];            
            if (this.selectedGstinCertficate) {
                this.gstinCertficateFilename = `${event.target.files[0].name}`; 
            }
            this.gstinCertficateType = this.selectedGstinCertficate.type;
            this.uploadGstin(this.selectedGstinCertficate);

        },

        uploadGstin : function () {
            var userData = localStorage.getItem('userData');
            var userInfo = JSON.parse(userData);
            let data = new FormData();
            data.append('file', this.selectedGstinCertficate)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.gstincertificate=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload GSTIN certificate',e);
                
            })
        
        },

        pincodeChange(pincode) {        
            this.$set(this.transporterObj, 'city', '');
            this.$set(this.transporterObj, 'state', '');

            const selectedPincode = this.pincodeCityData.find(
                item => item.vendorpincode == pincode.label
            );

            if (selectedPincode) {
                this.$set(this.transporterObj, 'city', selectedPincode.vendorcity);
                this.$set(this.transporterObj, 'state', selectedPincode.vendorstate);
            }
        },

        getPincodeList:function(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj={}
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
            .then((result)=>{
                if(result.body && result.body.returnmsg== "Successful"){
                    this.pincodeCityData = result.body.returnvalue;                    
                    for(let i=0;i<this.pincodeCityData.length;++i){
                        this.pincodes.push({
                            key:this.pincodeCityData[i].pincode,
                            label:this.pincodeCityData[i].pincode
                        })
                    }
                    console.log("pincodes-->",this.pincodes) 
                }
                else{
                    this.pincodes=[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        clearSearch() {
        this.filter = '';
        this.getTransporterList();
         },

    }
}
</script>
<style scoped>
.custom-open-modal {
  background-color: #C0EA47 !important;
}

.custom-close-modal {
  background-color: #EF7979 !important;
  margin-left: 5px !important;
}

.modal-content {
  text-align: center !important;
}

/* Ensure buttons are centered as well */
footer.column.has-text-center {
  text-align: center !important;
}


.custom-close {
  background-color: #FF8D2C !important;
  border-radius: 10px !important;
}

.custom-submit {
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
  border-radius: 10px !important;  
}
</style>
